export class Definitions {

  public static NEW_DELEGATION_TLD_TYPE_DESCRIPTION: string = "Type of domain defines what type of domain you are trying to delegate.";

  public static NEW_DELEGATION_CCTLD_MANAGER_DESCRIPTION: string = "The ccTLD Manager is the legal entity responsible for managing the domain in accordance with\n" +
    "the relevant delegation agreements.";

  public static NEW_DELEGATION_RO_DESCRIPTION: string = "The Registry Operator is the legal entity responsible for managing the domain in accordance with\n" +
    "the relevant delegation agreements.";

  public static NEW_DELEGATION_AC_DESCRIPTION: string = "The administrative contact is listed as a public contact point in the IANA WHOIS database.";

  public static NEW_DELEGATION_TC_DESCRIPTION: string = "The technical contact is listed as a public contact point in the IANA WHOIS database.";

  public static NEW_DELEGATION_NAMESERVERS_DESCRIPTION: string = "The authoritative name servers will be listed in the DNS Root Zone to enable the domain to\n" +
    "function. These should match the technical configuration provided during pre-delegation testing to\n" +
    "ICANN, and must meet <a href='https://www.iana.org/help/nameserver-requirements' target='_blank'>IANA technical requirements</a>.";

  public static NEW_DELEGATION_TRUSTANCHORS_DESCRIPTION: string = "These records enable the DNSSEC chain of trust to your domain. They are needed for DNSSEC enabled\n" +
    "domains.";

  public static NEW_DELEGATION_TRUSTANCHORS_DESCRIPTION_GTLD: string = "These records enable the DNSSEC chain of trust to your domain. They are needed for DNSSEC enabled \n" +
    "domains. These should match the technical configuration provided during pre-delegation testing to ICANN.";

  public static NEW_DELEGATION_ADDITIONALINFO_DESCRIPTION: string = "<p>IANA lists additional data in the IANA database to help customers who are looking for information\n" +
    "about top-level domains. Please provide a URL to a web page with information about the TLD\n" +
    "(typically the TLD registry’s home page), the hostname for the WHOIS server for the domain, and\n" +
    "the hostname for the RDAP server(s) for the domain.\n</p>" +
    "<p>Important: The WHOIS server must accept connections on port 43, such as \"whois.iana.org\", and should not be a URL.</p>";
}
